import {Component, Input, OnInit} from '@angular/core';
import {LevelsBase} from './levels';
import {ILevelBase, Level} from "./level";
import {GameSize} from "../game/game-size.service";

@Component({
  selector: 'app-levels',
  templateUrl: './levels.component.html',
  styleUrls: ['./levels.component.css']
})
export class LevelsComponent implements OnInit {

  @Input() levels: LevelsBase<Level<ILevelBase>>;

  constructor(private gameSize: GameSize) { }

  get width(): number {
    return this.gameSize.width;
  }

  ngOnInit(): void {}

  get style(): any {
    return {
      width: `${this.width}px`,
    };
  }
  get miniStyle(): any {
    return {
      width: `${(this.width * 0.9) / 3 - 1}px`,
      margin: `${this.width / 60 - 1}px`
    };
  }

  pickLevel(name: string): void {
    console.log(`todo pick a level by name ${name}`);
  }
}
